// extracted by mini-css-extract-plugin
export default {"trialFlag":"styles__trialFlag___T1KQV","text":"styles__text___ARKrd","strong":"styles__strong___ogiTp"};